// src/api/bookings.api.js
import axiosInstance from './axiosInstance';

/**
 * جلب قائمة الحجوزات مع الفلاتر الاختيارية
 * @param {Object} filters - { client_name, booking_type, status, start_date, end_date }
 */
export const fetchBookings = (filters = {}) => {
  const activeFilters = Object.fromEntries(
    Object.entries(filters).filter(([, v]) => v != null && v !== '')
  );
  return axiosInstance.get('/bookings/', { params: activeFilters });
};

/**
 * جلب تفاصيل حجز واحد
 * @param {number} id
 */
export const fetchBookingById = (id) =>
  axiosInstance.get(`/bookings/${id}/`);

/**
 * إنشاء حجز جديد
 * @param {Object} payload
 */
export const createBooking = (payload) =>
  axiosInstance.post('/bookings/', payload);

/**
 * تحديث بيانات حجز (جزئي)
 * @param {number} id
 * @param {Object} payload
 */
export const updateBooking = (id, payload) =>
  axiosInstance.patch(`/bookings/${id}/`, payload);

/**
 * تحديث حالة حجز فقط
 * @param {number} id
 * @param {string} status
 */
export const updateBookingStatus = (id, status) =>
  axiosInstance.patch(`/bookings/${id}/`, { status });

/**
 * حذف حجز
 * @param {number} id
 */
export const deleteBooking = (id) =>
  axiosInstance.delete(`/bookings/${id}/`);